import { Action } from '@ngrx/store';


export enum ECurrentUserGroupActions {
  StartNewUserGroup = '[User groups] Start new user group',
  GetCurrentUserGroup = '[User groups] Get Current User group',
  GetCurrentUserGroupSuccess = '[User groups] Get Current User group Success',
  UpdateUserGroup = '[User groups] Update User group',
  UpdateUserGroupSuccess = '[User groups] Update User group Success',
  ResetCurrentUserGroup = '[User groups] Reset current user group',
  CreateUserGroup = '[User groups] Create user group',
  CreateUserGroupSuccess = '[User groups] Create user group Success',
  SetCurrentGroup = '[User groups] Set current group',
  AddSpecificUser = '[Specific user] Add specific user',
  ModifySpecificUser = '[Specific user] Modify specific user',
  DeleteSpecificUser = '[Specific user] Delete specific user',
  UpdateLocalUserGroup = '[User groups] Update local current user group'
}

export class StartNewUserGroup implements Action {
  public readonly type = ECurrentUserGroupActions.StartNewUserGroup;
}

export class GetCurrentUserGroup implements Action {
  public readonly type = ECurrentUserGroupActions.GetCurrentUserGroup;
  constructor(public payload: Guid) { }
}

export class GetCurrentUserGroupSuccess implements Action {
  public readonly type = ECurrentUserGroupActions.GetCurrentUserGroupSuccess;
  constructor(public payload: any) { }
}

export class UpdateUserGroup implements Action {
  public readonly type = ECurrentUserGroupActions.UpdateUserGroup;
  constructor(public payload: IUserGroup) { }
}

export class UpdateUserGroupSuccess implements Action {
  public readonly type = ECurrentUserGroupActions.UpdateUserGroupSuccess;
}

export class ResetCurrentUserGroup implements Action {
  public readonly type = ECurrentUserGroupActions.ResetCurrentUserGroup;
  constructor() { }
}

export class CreateUserGroup implements Action {
  public readonly type = ECurrentUserGroupActions.CreateUserGroup;
  constructor(public payload: IUserGroup) { }
}

export class CreateUserGroupSuccess implements Action {
  public readonly type = ECurrentUserGroupActions.CreateUserGroupSuccess;
  constructor(public payload: IUserGroup) {
  }
}

export class SetCurrentGroup implements Action {
  public readonly type = ECurrentUserGroupActions.SetCurrentGroup;
  constructor(public payload: IUserGroup) {
  }
}

export class AddSpecificUser implements Action {
  public readonly type = ECurrentUserGroupActions.AddSpecificUser;
  constructor(public payload: IUserGroupUser) { }
}

export class ModifySpecificUser implements Action {
  public readonly type = ECurrentUserGroupActions.ModifySpecificUser;
  constructor(public payload: IUserGroupUser) { }
}

export class DeleteSpecificUser implements Action {
  public readonly type = ECurrentUserGroupActions.DeleteSpecificUser;
  constructor(public payload: number) { }
}

export class UpdateLocalUserGroup implements Action {
  public readonly type = ECurrentUserGroupActions.UpdateLocalUserGroup;
  constructor(public payload: any) {
  }
}
export type CurrentUserGroupActions = GetCurrentUserGroup |
  GetCurrentUserGroupSuccess |
  UpdateUserGroup |
  UpdateUserGroupSuccess |
  ResetCurrentUserGroup |
  CreateUserGroup |
  CreateUserGroupSuccess |
  AddSpecificUser |
  ModifySpecificUser |
  DeleteSpecificUser |
  StartNewUserGroup |
  UpdateLocalUserGroup;
